import { PlanungLookupProjekte } from '@/types/service-response'
import moment from 'moment'

export class PlanningLookupProject {
  private constructor (
    readonly id: number,
    readonly nummer: string | null,
    readonly titel: string | null,
    readonly adressNummer: string | null,
    readonly adressLinie: string | null,
    readonly label: string,
    readonly projektDatum: string | null
  ) {}

  public static createListFromResponse (data: PlanungLookupProjekte[]): PlanningLookupProject[] {
    return data.map((item: PlanungLookupProjekte): PlanningLookupProject => {
      return new PlanningLookupProject(
        item.ID,
        item.Nummer,
        item.Titel,
        item.AdressNummer,
        item.AdressLinie,
        `${item.Nummer} / ${item.Titel} ${item.ProjektDatum ? '/' : ''} ${item.ProjektDatum ? moment(item.ProjektDatum).format('DD.MM.YYYY') : ''}`,
        item.ProjektDatum
      )
    })
  }
}
